import React from 'react';

export interface ColourPickerColour {
  id: number;
  name: string;
  swatchImage?: string | null;
  /** Full product photo for this colour, preloaded on hover (distinct from the small swatch icon). */
  productImage?: string | null;
  hexColours?: string[];
  isSelected: boolean;
  isDisabled: boolean;
  isDeal: boolean;
}

export type ColourPickerVariant = 'pdp' | 'card';

export interface ColourPickerContextValue {
  state: { colours: ColourPickerColour[] };
  actions: { onSelectColour: (id: number) => void };
  variant?: ColourPickerVariant;
  /** When set (PLP card collapsed with overflow), only swatches with index < this are focusable. */
  overflowCollapsedVisibleCount?: number | null;
  /**
   * The `sizes` string of the `next/image` this picker's swatches will make appear
   * on select (PDP gallery hero slide, or the PLP/strip tile image) — must match
   * exactly, since hover-preload uses it to resolve the same optimizer cache key
   * the real image will request. A mismatch (e.g. reusing the PDP gallery's sizes
   * for a PLP tile) preloads the wrong resource and the perceived delay returns.
   */
  preloadImageSizes: string;
}

export const ColourPickerContext =
  React.createContext<ColourPickerContextValue | null>(null);

export const useColourPickerContext = (): ColourPickerContextValue => {
  const ctx = React.useContext(ColourPickerContext);

  if (!ctx) {
    throw new Error(
      'useColourPickerContext must be used within a ColourPickerContext.Provider'
    );
  }

  return ctx;
};
